/** AsyncStorage key for a World Cup squad invite code awaiting post-sign-in processing. */
export const PENDING_WC_SQUAD_JOIN_STORAGE_KEY = '@zporti/pending_wc_squad_join';

/** Web sessionStorage mirror — survives an OAuth redirect in the same tab. */
export const PENDING_WC_SQUAD_JOIN_SESSION_KEY = 'zporti_pending_wc_squad_join';

/** Drop stale pending codes after 7 days. */
export const PENDING_WC_SQUAD_JOIN_TTL_MS = 7 * 24 * 60 * 60 * 1000;

/**
 * Query-param name carrying a WC squad-join code on the OAuth redirect URL. This is
 * the only carrier that survives a cross-app OAuth handoff (in-app browser → system
 * Safari), where both sessionStorage and localStorage live in a different browser and
 * are lost. The `/oauth-native-callback` page reads it back and routes to the join.
 */
export const WC_JOIN_OAUTH_PARAM = 'wc_join';

/**
 * Companion param carrying WHICH competition the code belongs to. Invite codes are
 * only unique per competition, so without this a non-WC code is resolved against the
 * World Cup and 404s (or, worse, collides with a real WC squad). Emitted only for
 * non-WC joins so the dominant World Cup redirect URL stays byte-identical, and read
 * back as World Cup when absent — links already in flight keep working.
 */
export const WC_JOIN_COMPETITION_OAUTH_PARAM = 'wc_join_c';
